import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(id: string, putObject: Request): Promise<Optional<void>> {
	const url = `${SERVICEBASEURL.BACKEND}/NutriScoreLabel/${id}`;
	return axios.put(url, putObject).toOptionalVoid();
}

export interface Request {
	isFluid: boolean;
	maxValue: number | null;
	color: string;
	rank: number;
	labelTranslations: {
		[key: string]: string;
	};
}
